import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import UserNavbar from "components/UserNavbar/UserNavbar";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import blogPosts from "../log/BlogData";

export default function Bloginfo() {
  const { slug } = useParams();
  const location = useLocation();
  const [post, setPost] = useState(location.state);

  // If navigated directly (no state), find post by slug
  useEffect(() => {
    if (!post) {
      const found = blogPosts?.find(
        (p) =>
          p.title
            .toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/[^\w\-]/g, "") === slug
      );
      setPost(found);
    }
  }, [post, slug]);

  if (!post) {
    return (
      <section className="min-h-screen p-8">
        <p>Loading...</p>
      </section>
    );
  }

  const { imglg, content } = post;

  return (
    <section className="min-h-screen bg-gray-50 text-gray-800">
      <UserNavbar />
      <ScrollToTopOnRouteChange />

      <div className="mx-auto max-w-5xl px-4 py-10">
        {/* Blog Header Image */}
        <div className="mb-8 overflow-hidden rounded-xl shadow-md">
          <img
            src={imglg}
            alt={post.title}
            className="w-full object-cover transition-transform duration-500 hover:scale-105 sm:h-[400px]"
          />
        </div>

        {/* Blog Content */}
        <div className="space-y-10">
          {content.map((section, index) => (
            <div key={index}>
              <h2 className="mb-4 border-l-4 border-red-500 pl-3 text-2xl font-bold text-gray-900 sm:text-3xl">
                {section.title}
              </h2>
              <ul className="list-disc space-y-3 pl-6 text-base leading-relaxed text-gray-700">
                {section.points.map((point, idx) => (
                  <li key={idx}>
                    {point.includes(":") ? (
                      <>
                        <span className="font-semibold">
                          {point.split(":")[0]}:
                        </span>
                        {point.split(":")[1]}
                      </>
                    ) : (
                      point
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
